<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Please Provide Justification</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <nf-form-control
    label="Justification"
    [customErrorMessages]="customErrorMessages"
  >
    <textarea
      name="justification"
      id="justification"
      [formControl]="justification"
      class="form-control"
      rows="3"
    ></textarea>
  </nf-form-control>

  <p>
    The action you are about to perform requires Approval. Click 'OK' to submit
    a Request which can be tracked in the Approvals panel
  </p>
</div>

<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()">Cancel</button>
    <button
      nf-button="save"
      [disabled]="justification.invalid"
      (click)="activeModal.close(justification.value)"
    >
      OK
    </button>
  </div>
</div>
